module.exports = __webpack_public_path__ + "media/images/user-80070bba.png";